<template>
  <div>
    <div class="kqf-card mg10 search-box mt20">
      <el-form
        :inline="true"
        :model="search"
        size="mini"
        class="demo-form-inline"
      >
        <el-col :span="24">
          <el-form-item label="黑名单">
            <el-radio-group v-model="search.is_lock" @input="getList(1)">
              <el-radio :label="-1">全部</el-radio>
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="享有免费次数" class="ml20">
            <el-radio-group v-model="search.is_free" @input="getList(1)">
              <el-radio :label="-1">全部</el-radio>
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="钱包余额" class="ml20">
            <el-radio-group v-model="search.is_money" @input="getList(1)">
              <el-radio :label="-1">全部</el-radio>
              <el-radio :label="0">无</el-radio>
              <el-radio :label="1">有</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="账号佣金">
            <el-radio-group v-model="search.is_commission" @input="getList(1)">
              <el-radio :label="-1">全部</el-radio>
              <el-radio :label="1">有</el-radio>
              <el-radio :label="0">无</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="账号积分" class="ml20">
            <el-radio-group v-model="search.is_score" @input="getList(1)">
              <el-radio :label="-1">全部</el-radio>
              <el-radio :label="1">有</el-radio>
              <el-radio :label="0">无</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="公众号关注" class="ml20">
            <el-radio-group v-model="search.is_focus_mp" @input="getList(1)">
              <el-radio :label="-1">全部</el-radio>
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <div class="line-dashed mb10"></div>
        </el-col>

        <el-form-item label="关键字：">
          <el-input
            v-model="search.keyword"
            placeholder="请输入昵称或手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="推广者UID：" class="ml20">
          <el-input
            v-model="search.agent_uid"
            placeholder="请输入uid"
          ></el-input>
        </el-form-item>
        <el-form-item label="注册时间">
          <el-date-picker
            v-model="search.create_time"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList(1)">查询</el-button>
          <el-button @click="refresh">重置</el-button>
        </el-form-item>
        <el-form-item>
          <div class="allMoney">
            总查询余额：<span class="num">{{ datas.total_money }}</span>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="allMoney">
            总佣金：<span class="num">{{ datas.total_commission }}</span>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="allMoney">
            总积分：<span class="num">{{ datas.total_score }}</span>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="allMoney">
            推广人数：<span class="num">{{ datas.total_friend_count }}</span>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="allMoney">
            关注公众数：<span class="num">{{
              datas.total_focus_give_count
            }}</span>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div
      class="kqf-card mg10 pd10 mt20"
      v-loading="loading"
      style="min-width: 1100px"
    >
      <el-table
        border
        :data="datas.list"
        height="calc(100vh - 280px)"
        @sort-change="orderby"
      >
        <el-table-column label="UID" width="80" prop="uid"></el-table-column>
        <el-table-column label="用户信息" width="350">
          <template slot-scope="scope">
            <div class="flex">
              <div style="margin-left: 10px">
                <p class="text-over">微信昵称：{{ scope.row.nickname }}</p>
                <p class="text-over">openid：{{ scope.row.openid }}</p>
                <el-link
                  v-clipboard:success="copySuccess"
                  v-clipboard:copy="scope.row.mobile"
                  type="primary"
                  :underline="false"
                  >手机号：{{ scope.row.mobile }}
                </el-link>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="推广者" width="350">
          <template slot-scope="scope">
            <div class="flex">
              <p v-if="!scope.row.agent_uid" class="text-info">--</p>
              <div v-else class="flex">
                <div class="ml10">
                  <p class="text-over">
                    微信昵称：{{ scope.row.hasAgent_nickname }}
                  </p>
                  <p class="text-over">
                    openid：{{ scope.row.hasAgent_openid }}
                  </p>
                  <p>
                    <el-link
                      v-clipboard:success="copySuccess"
                      v-clipboard:copy="scope.row.hasAgent_mobile"
                      type="primary"
                      :underline="false"
                      >{{ scope.row.hasAgent_mobile }}
                    </el-link>
                    <span> 手机号：({{ scope.row.agent_uid }}) </span>
                  </p>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="推广人数" prop="agent_num" sortable width="130">
          <template slot-scope="scope">
            <p>
              <el-link
                @click="toInvite(scope.row.uid)"
                type="primary"
                :underline="false"
                >{{ scope.row.agent_num }}
              </el-link>
            </p>
          </template>
        </el-table-column>
        <el-table-column label="下单人数" prop="order_num" sortable width="130">
          <template slot-scope="scope">
            <p>{{ scope.row.order_num }}</p>
          </template>
        </el-table-column>
        <el-table-column label="查询余额" sortable prop="money" width="130">
          <template slot-scope="scope">
            <div>￥{{ scope.row.money }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="账号佣金"
          sortable
          prop="commission"
          width="130"
        >
          <template slot-scope="scope">
            <div>￥{{ scope.row.commission }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="账号积分"
          sortable
          prop="score"
          width="130"
        ></el-table-column>
        <el-table-column
          label="注册时间"
          sortable
          prop="created_at"
          width="180"
        >
          <template slot-scope="scope">
            <p>{{ scope.row.created_at }}</p>
          </template>
        </el-table-column>
        <el-table-column label="是否关注公众号">
          <template slot-scope="scope">
            <div>{{ scope.row.is_focus_mp == 1 ? "是" : "否" }}</div>
          </template>
        </el-table-column>
        <el-table-column label="黑名单" width="80">
          <template slot-scope="scope">
            <el-switch
              @input="storeOnlineEnv(scope.row)"
              :active-value="1"
              :inactive-value="0"
              :value="scope.row.is_lock"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="享有免费次数" width="120">
          <template slot-scope="scope">
            <el-switch
              @input="freeEnv(scope.row)"
              :active-value="1"
              :inactive-value="0"
              :value="scope.row.is_free"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="editinfo(scope.row)"
              icon="el-icon-edit"
              type="primary"
              style="margin-right: 10px"
              >充值</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="flex center mt10">
        <div>
          <el-pagination
            @current-change="getList"
            :current-page="search.page"
            background
            :page-size="datas.limit"
            layout="total, prev, pager, next"
            :total="datas.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!--充值余额-->
    <el-dialog title="充值余额" :visible.sync="editdialog" width="600px">
      <el-form label-width="130px" size="small" v-loading="editloading">
        <el-form-item label="金额：" required>
          <el-input v-model="editdata.pay_money" style="width: 220px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="edit()">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { userIndex, lockUser, freeUser, setpay } from "../../request/api/user";

export default {
  data() {
    return {
      datas: [],
      search: this.getSearch(),
      //编辑信息
      editloading: false,
      editdialog: false,
      editdata: {
        uid: 0,
        pay_money: ""
      },
      loading: false
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getSearch() {
      return {
        is_focus_mp: -1,
        is_money: -1,
        is_lock: -1,
        is_free: -1,
        keyword: "",
        agent_uid: "",
        page: 1,
        is_commission: -1,
        is_score: -1,
        create_time: [],
        sort: ""
      };
    },
    getList(page) {
      this.search.page = page;
      this.loading = true;
      userIndex({
        page: page,
        keyword: this.search.keyword,
        is_focus_mp: this.search.is_focus_mp,
        is_money: this.search.is_money,
        is_lock: this.search.is_lock,
        agent_uid: this.search.agent_uid,
        is_free: this.search.is_free,
        is_commission: this.search.is_commission,
        is_score: this.search.is_score,
        create_time: this.search.create_time,
        sort: this.search.sort
      })
        .then(res => {
          this.datas = res;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    refresh() {
      this.search = this.getSearch();
      this.getList(1);
    },
    // 复制
    copySuccess() {
      this.$message.success("复制成功");
    },
    storeOnlineEnv(row) {
      this.loading = true;
      lockUser({ uid: row.uid })
        .then(() => {
          row.is_lock ^= 1;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    freeEnv(row) {
      this.loading = true;
      freeUser({ uid: row.uid })
        .then(() => {
          row.is_free ^= 1;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //编辑信息填入
    editinfo(row) {
      this.editdialog = true;
      this.editdata = Object.assign(this.editdata, row);
    },
    //充值
    edit() {
      this.editloading = true;
      setpay({
        ...this.editdata
      })
        .then(() => {
          this.editdialog = false;
          this.$message.success("操作成功");
          this.editloading = false;
          this.getList(1);
          this.editloading = false;
          this.editdata = {
            pay_money: ""
          };
        })
        .catch(() => {
          this.editloading = false;
        });
    },
    toInvite(id) {
      this.$router.push({ path: "/user/inviteUser", query: { id } });
    },
    orderby(e) {
      if (e.order != null) {
        let order = e.order == "descending" ? "desc" : "asc";
        this.search.sort = e.prop + "_" + order;
      } else {
        this.search.sort = "";
      }
      this.getList(1);
    }
  }
};
</script>
<style scoped>
.allMoney {
  margin-left: 20px;
}
.allMoney .num {
  font-size: 15px;
  color: #ff5646;
}
</style>
